module.exports = __webpack_public_path__ + "static/media/8-item-a.b9a10876.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/8-item-a.jpg
// module id = 1211
// module chunks = 33